import * as React from 'react';
// import { apiMain } from '../App';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
// import { getLanLoc } from '../components/Functions/LangFunc';
// import { GetDataPromise } from '../components/Functions/SendingData';
import { useState } from 'react';
// import { MainData } from '../Data/MainData';
import PageLayout from '../layouts/PageLayout';
// import { Dictionery } from '../Data/Dictionery';
// import { IconClose } from '../Assets/IconClose';
import styled from 'styled-components';
import { TextInputWTitle } from '../Inputs/TextInputWTitle';
 import { TextBtn } from '../Inputs/TextBtn';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
// import { havePermission, haveRole } from '../components/Functions/PermissionCheck';
import backgroundImage from "../images/login-bg.webp"
 import { TextBtn2 } from '../Inputs/TextBtn2';
const Styles = styled.div`
  height: 100svh;
  display: flex;

  flex-direction: column;
  isolation: isolate;
  position: relative;
  .background {
    z-index: -1;
    position: absolute;
    inset: 0;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
  .column {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .row {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 1rem;
    gap: 0.5rem;
  }
  .links {
    min-width: 100px;
    max-width: 150px;
    background-color: var(--n-grey-0);
    border: 1px solid #E5E5E590;
    border-radius: 1.5rem;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    text-decoration: none;
    color: inherit;
    .title {
      font-size: 1.2rem;
      font-weight: 700;
    }
  }
  .box {
    min-width: 350px;
    max-width: 450px;
    margin: 1rem;
    background-color: var(--n-grey-0);
    border: 1px solid #E5E5E590;
    border-radius: 1.5rem;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    .field {
      display: flex;
      flex-direction: column;
    }
    .title {
      display: flex;
      justify-content: space-between;
      .text {
        font-weight: 600;
      }
      .action {
        cursor: pointer;
      }
    }
    .line {
      height: 1px;
      background-color: #E5E5E5;
    }
    .desc {
      color: var(--n-grey-2);
    }
    .forget-password {
      margin: 0 0.1rem 0.8rem;
      text-decoration: none;
      font-weight: 700;
      align-self: flex-start;
    }
  }
`

export default function SignInSide(props) {
  const {user} = props;
  const location = useLocation();
  const params = useParams();
  const navigation = useNavigate();
//   const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
//   let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);
//   let lang=(lan ? MainData.dict[0] : MainData.dict[1])

  const handleSubmit = async (event) => {
    event.preventDefault();
    const fdata = new FormData(event.currentTarget);
//     try {
//     //   setLoading(true);
//       setErrors({})
//       let params = new URLSearchParams();
//       params.append("U_EMAIL", fdata.get('email'));
//       params.append("U_PASSWORD", fdata.get('password'));
//     //   let res = await GetDataPromise(`${apiMain}/api/v1/user/user_login_email?${params.toString()}`, true);
//     //   let parsed = JSON.parse(res);
//       if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
//         // const userdata =  {
//         //   ...parsed.data,
//         //   permission: parsed.permission,
//         // };
//         localStorage.setItem("luxtrip-user", JSON.stringify(userdata));
//         props.setUser(userdata);
      
//         // navigation("/" + lang.filename + "/profile/dashboard");
//         // setLoading(false);
//         return;
//       }
//     //   setLoading(false);
//       setErrors(parsed.data.message)
//     } catch (error) {
//       console.log(error)
//     }
//     // setLoading(false)
   };
  const onChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    setFormData(prev => {
      prev[name] = value;
      return {...prev}
    })
  }

//   

  const makeLink = (text, icon, role, link = '') => {
    // check roll
    let object = {};
    let hasIt = false;
    switch(role){
      case"broker":
        // hasIt = haveRole(user.permission, {Obj_Code: 5});
        break;
      case "agency":
        // hasIt = haveRole(user.permission, {Obj_Code: 4});
        break;
      case "admin":
        // hasIt = havePermission(user.permission, {Agency_Id: 0, Obj_Code: 1});
        break;
      case"all":
        hasIt = true;
        break;
      default:
        break;
    }
    if(hasIt){
      return (
        <Link to={link} className='links'>
          <div className='icon'>
            {icon}
          </div>
          <div className='title'>
            {text}
          </div>
        </Link>
      )
    }
  }
//   if(user.email){
    return (
      <PageLayout 
        {...props} 
        // language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
        // dict={MainData.dict} 
        // mainLogo={MainData.mainLogo} 
        // texts={MainData.texts} 
        // nav={MainData.nav} 
        // footer={MainData.footer} 
        // login={MainData.login}
      >
        <Styles>
          <div className='background'>
            <img src='https://testapi.luxintrip.com/images/23.jpg' alt='background ocean'/>
          </div>
          <div className="navpad"></div>
          <div className='row'>
            {/* {makeLink(Dictionery.mainWebsite[lang.filename], <CampaignRoundedIcon fontSize='large'/>, "all", "/" + lang.filename + "/")} */}
          </div>
        </Styles>
      </PageLayout>
    )
//   }

  return (
     <PageLayout 
       {...props} 
    //   language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
    //   dict={MainData.dict} 
    //   mainLogo={MainData.mainLogo} 
    //   texts={MainData.texts} 
    //   nav={MainData.nav} 
    //   footer={MainData.footer} 
    //   login={MainData.login}
    >

      <Styles>
        <div className='background'>
          <img src={backgroundImage} alt='background ocean'/>
        </div>
        <div className="navpad"></div>
        <div className='column'>
          <div className='box'>
            <div className='title'>
              <div className='text'>
                Login
                {/* {Dictionery.loginSignupBtn[lang.filename]} */}
              </div>
              <div className='action' onClick={() => navigation("/")}>
                {/* <IconClose style={{fill: "#1E1E1E"}}/> */}
              </div>
            </div>
            <div className='line'>
            </div>
            <div className='desc'>
              Login
              {/* {Dictionery.loginSignupDesc[lang.filename]} */}
            </div>
            <form className='field' onSubmit={handleSubmit}>
              <TextInputWTitle
                title='Login' //{Dictionery.loginSignupInsput1[lang.filename]}
                onchange={onChange}
                name={"email"}
                value={formData.email}
                error={(errors.U_EMAIL) ? errors.U_EMAIL : ""}
                lan='en'//{lan}
                ltr='ltr'//{lan}
              />
              <TextInputWTitle
                title='Password' //{Dictionery.loginSignupInput2[lang.filename]}
                onchange={onChange}
                name={"password"}
                value={formData.password}
                type='password'
                lan='en'//{lan}
                error={(errors.U_PASSWORD) ? errors.U_PASSWORD : ""}
                ltr='ltr'//{lan}
              />
              {/* <Link to={ "/forget-password"} className='forget-password'>
               "password"
                { //Dictionery.forgetPassword["password"]
              </Link> */}
            <TextBtn 
             type={"submit"}
             text='Login' //{Dictionery.loginSignupBtn[lang.filename]}
                // loading={loading}
                // disabled={loading}
            />

               <TextBtn2
                newType={3}
                 onclick={() => {
                    navigation("/signup")
                }}
                 text={'Sign up' 
              }
              //Dictionery.signupBtn[lang.filename]}
              /> 
           </form>
          </div>
        </div>
      </Styles>
  
     </PageLayout>
  )
}